export default __webpack_public_path__ + "locales/vi/FilesSettings.json?hash=98317113fedf2b0dc391a81bac45439b";